// Could make this a provider, but don;t really see a benefit to that
export const config = {
  // @todo make configurable at build time.
  apiUrl: process.env.REACT_APP_API_URL || 'http://localhost:4000',
  environment: process.env.REACT_APP_ENV || 'development',
};
